import { isApiError } from "@simpro/api-client";
import { toast } from "@simpro/ui";
import { MutationCache, QueryClient } from "@tanstack/react-query";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: {
      /** Skip the global "something went wrong" toast; the caller shows the error itself. */
      silent?: boolean;
    };
  }
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // Client errors will not fix themselves; retry only transport/server failures once.
        retry: (failureCount, error) =>
          failureCount < 1 &&
          !(isApiError(error) && error.statusCode > 0 && error.statusCode < 500),
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.silent) return;
        toast.error(
          "Something went wrong",
          isApiError(error) ? error.message : "Please try again in a moment.",
        );
      },
    }),
  });
}
